import type { PageHeroProps } from "../types";
import { PageHeroPrimary } from "./primary/page-hero-primary";
import { PageHeroSecondary } from "./secondary/page-hero-secondary";

export const PageHero = (props: PageHeroProps) => {
  const { variant } = props;

  if (variant === "primary") {
    return <PageHeroPrimary {...props} />;
  }

  return <PageHeroSecondary {...props} />;
};
